export default __webpack_public_path__ + "static/media/blaster.17262851.png";